export default "__VITE_ASSET__DFSACeih__"